module.exports = __webpack_public_path__ + "static/riding_horse-59bd573ad28c00b64896c6591d47dea5.jpg";